<div class="spinner" [ngStyle]="{display: show ? 'flex' : 'none'}">
    <span>{{ message }}</span>
    <p-progressSpinner ariaLabel="loading" />
</div>